const paths = {
  dashboard: '/dashboard'
};

export default paths;
